<template>
    <vue-scroll :ops="$ops">
        <div v-loading="$parentInfo.studentCart.dialog_ChooseClassPlan.loading" style="max-height:400px">
            <table class="table table-striped">
                <thead>
                <tr>
                    <th>课次ID</th>
                    <th>开始日期</th>
                    <th>开始时间</th>
                    <th>结束时间</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in $parentInfo.studentCart.studentCart_classPlans" :key="item.id">
                    <td>{{item.classPlan.id}}</td>
                    <td>{{item.classPlan.date}}</td>
                    <td>{{item.classPlan.template_time_semester.start_time}}</td>
                    <td>{{item.classPlan.template_time_semester.end_time}}</td>
                    <td v-if="item.status =='end'">
                        <el-button
                                plain
                                size="mini"
                                type="primary"
                                disabled>已购
                        </el-button>
                    </td>
                    <td v-else-if="item.status =='over'">
                        <el-button
                                plain
                                size="mini"
                                type="primary"
                                disabled>已结束
                        </el-button>
                    </td>
                    <td v-else-if="item.status!='finished'">
                        <el-button
                                :class="{checked:item.status=='cancel'}"
                                :disabled="item.status=='cancel'"
                                type="primary" plain size="mini"
                                @click="selectClassPlan(item.id,'cancel')"
                                :loading="$parentInfo.studentCart.dialog_ChooseClassPlan.button_loading">退课
                        </el-button>
                        <el-button
                                plain
                                size="mini"
                                type="primary"
                                :class="{checked:item.status=='active'}"
                                :disabled="item.status=='active'"
                                @click="selectClassPlan(item.id,'active')"
                                :loading="$parentInfo.studentCart.dialog_ChooseClassPlan.button_loading">选择
                        </el-button>
                        <el-button
                                plain
                                size="mini"
                                type="primary"
                                v-if="item.status=='staging'"
                                :disabled="item.status=='staging'"
                                @click="selectClassPlan(item.id,'staging')"
                                :loading="$parentInfo.studentCart.dialog_ChooseClassPlan.button_loading">分期
                        </el-button>
                    </td>
                    <td v-else>
                        <el-button
                                plain
                                size="mini"
                                type="primary"
                                disabled>已上
                        </el-button>
                    </td>
                </tr>
                </tbody>
            </table>
            <!--<div v-for="studentCart in studentCart_classPlan">-->
            <!--{{studentCart}}-->
            <!--</div>-->

        </div>
    </vue-scroll>
</template>

<script>
    export default {
        data() {
            return {};
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentCart.dialog_ChooseClassPlan.loading = true;
            this.$parentInfo.studentCart.dialog_ChooseClassPlan.button_loading = false;
            this.handleClassPlan();
        },
        methods: {
            //取得课程课时情况 true
            handleClassPlan() {
                this.$wApi.send(this.$parentInfo.path, 'getClassPlan', {
                    'studentCart_id': this.$store.state.modal.data.cart_id,
                });
            },
            //选课 true
            selectClassPlan(studentCartClassPlan_id, status) {
                this.$parentInfo.studentCart.dialog_ChooseClassPlan.button_loading = true;
                this.$parentInfo.studentCart.dialog_ChooseClassPlan.status = status;
                this.$parentInfo.studentCart.dialog_ChooseClassPlan.studentCartClassPlan_id = studentCartClassPlan_id;
                this.$wApi.send(this.$parentInfo.path, 'selectClassPlan', {
                    'student_id': this.$parentInfo.student_id,
                    'studentCartClassPlan_id': studentCartClassPlan_id,
                    'status': status,
                });
            },
        }
    };
</script>

<style scoped>
    .checked {
        background: #0b67cd;
    }
</style>